module.exports = __webpack_public_path__ + "static/media/af.409e1e59.svg";